module.exports = __webpack_public_path__ + "img/SketchPng4e27d3cf4cf73e9212295d16d88a5c48430367d1517f23050c2a0b711621d41b.32f511cf.png";